export class NewOrderRecipeInput {
    orderId: number;
    recipeId: number;
    formData: FormData;
}